import type { FormEvent } from 'react'

import { useState } from 'react'

export type ContactStatus = 'idle' | 'sending' | 'done' | 'error'

/** Which form the enquiry came from, stored alongside the submission. */
export type ContactSource = 'Contact page' | 'Booking page'

export type ContactValues = {
    name: string
    email: string
    phone: string
    projectType: string
    preferredDate: string
    message: string
}

const INITIAL: ContactValues = {
    name: '',
    email: '',
    phone: '',
    projectType: '',
    preferredDate: '',
    message: ''
}

export const useContactForm = (source: ContactSource = 'Contact page') => {
    const [values, setValues] = useState<ContactValues>(INITIAL)
    const [status, setStatus] = useState<ContactStatus>('idle')

    const update = (field: keyof ContactValues, value: string): void =>
        setValues((current) => ({ ...current, [field]: value }))

    const onSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
        event.preventDefault()
        setStatus('sending')

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...values, source })
            })

            if (!response.ok) {
                throw new Error('Request failed')
            }

            setValues(INITIAL)
            setStatus('done')
        } catch {
            setStatus('error')
        }
    }

    return {
        values,
        status,
        update,
        onSubmit
    }
}
